<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      Add Parking Place
      <!-- <small>Preview</small> -->
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/user/home">
          <i class="fa fa-dashboard"></i> Home</a>
      </li>
      <li class="active">Add Parking Place</li>
    </ol>
  </section>

  <!-- Main content -->
  <section class="content">
    <div class="row">
      <!-- left column -->
      <div class="col-md-12">
        <!-- general form elements -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <!-- <h3 class="box-title">Quick Example</h3> -->
          </div>
          <!-- /.box-header -->
          <!-- form start -->
          <add-parking-place (submit)="saveParkingPlace($event)"></add-parking-place>
        </div>
        <!-- /.box -->

      </div>
      <!--/.col (left) -->
      <!-- right column -->

      <!--/.col (right) -->
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->
